<!-- PrimeNG Sidebar Navigation -->
<div
  class="sidebar-nav-container"
  [ngClass]="{ expanded: isExpanded, collapsed: !isExpanded }"
>
  <!-- Brand/Logo Section -->
  <div class="sidebar-brand">
    <div class="brand-content">
      <div
        class="brand-icon"
        (click)="backRoute()"
        role="button"
        tabindex="0"
        (keydown.enter)="
          $event.target === $event.currentTarget &&
            $any($event.currentTarget).click()
        "
        (keydown.space)="
          $event.target === $event.currentTarget && $event.preventDefault();
          $event.target === $event.currentTarget &&
            $any($event.currentTarget).click()
        "
      >
        @if (!isExpanded) {
          <!-- Collapsed Logo - Square Container -->
          <div class="collapsed-logo-container">
            @if (logoData?.img) {
              <img [src]="logoData?.img" alt="logo" class="collapsed-logo" />
            } @else {
              <img
                src="assets/images/gemfin-logo.svg"
                alt="GEMFIN Logo"
                class="collapsed-logo"
              />
            }
          </div>
        } @else {
          <!-- Expanded Logo -->
          <div class="logo-wrapper">
            @if (logoData?.img) {
              <img [src]="logoData?.img" alt="logo" class="logo-img" />
            } @else {
              <img
                src="assets/images/gemfin-logo.svg"
                alt="GEMFIN Logo"
                class="logo-img"
              />
            }
          </div>
        }
      </div>
    </div>
  </div>

  <div class="sidebar-menu">
    <!-- Admin Section -->
    @if (role === 'ADMIN') {
      <div class="menu-section">
        @if (isExpanded) {
          <div class="section-header">
            <span class="section-title">ADMIN</span>
          </div>
        }

        <p-button
          [routerLink]="'/product-admin/dashboard'"
          routerLinkActive="active-menu-item"
          #rlaAdminHome="routerLinkActive"
          [routerLinkActiveOptions]="{ exact: true }"
          styleClass="sidebar-nav-button"
          [text]="true"
          (onClick)="clearClientPortfolioStorage()"
        >
          <i
            class="pi pi-home sidebar-icon"
            [ngClass]="{ 'active-icon': rlaAdminHome.isActive }"
          ></i>
          @if (isExpanded) {
            <span class="sidebar-text">Home</span>
          }
        </p-button>

        <p-button
          [routerLink]="'/product-admin/dbf-file-viewer'"
          routerLinkActive="active-menu-item"
          #rlaMarketFile="routerLinkActive"
          [routerLinkActiveOptions]="{ exact: true }"
          styleClass="sidebar-nav-button"
          [text]="true"
          (onClick)="clearClientPortfolioStorage()"
        >
          <i
            class="pi pi-database sidebar-icon"
            [ngClass]="{ 'active-icon': rlaMarketFile.isActive }"
          ></i>
          @if (isExpanded) {
            <span class="sidebar-text">DBF File Viewer</span>
          }
        </p-button>
      </div>
    }
    <!-- Organization Section -->
    @if (
      role === 'BROKER ADMIN' ||
      role === 'RELATIONSHIP MANAGER' ||
      role === 'ADVISOR'
    ) {
      <div class="menu-section">
        @if (isExpanded) {
          <div class="section-header">
            <span class="section-title">ORGANIZATION</span>
          </div>
        }

        <p-button
          [routerLink]="['/', roleRoute, 'clients']"
          routerLinkActive="active-menu-item"
          #rla="routerLinkActive"
          [routerLinkActiveOptions]="{ exact: true }"
          styleClass="sidebar-nav-button"
          [text]="true"
          (onClick)="clearClientPortfolioStorage()"
        >
          <i
            class="pi pi-users sidebar-icon"
            [ngClass]="{ 'active-icon': rla.isActive }"
          ></i>
          @if (isExpanded) {
            <span class="sidebar-text">Clients</span>
          }
        </p-button>
        @if (role === 'BROKER ADMIN' || role === 'ADVISOR') {
          <p-button
            [routerLink]="
              role === 'BROKER ADMIN'
                ? ['/broker/brokers-list']
                : ['/advisor/advisors-list']
            "
            [queryParams]="
              role === 'BROKER ADMIN' ? { tab: 'brokers' } : { tab: 'advisors' }
            "
            routerLinkActive="active-menu-item"
            #rla1="routerLinkActive"
            [routerLinkActiveOptions]="{ exact: true }"
            styleClass="sidebar-nav-button"
            [text]="true"
            (onClick)="clearClientPortfolioStorage()"
          >
            <i
              class="pi pi-briefcase sidebar-icon"
              [ngClass]="{ 'active-icon': rla1.isActive }"
            ></i>
            @if (isExpanded) {
              <span class="sidebar-text">
                {{ role === 'BROKER ADMIN' ? 'Brokers/RMs' : 'Advisors/RMs' }}
              </span>
            }
          </p-button>
        }
        <div
          style="border-top: 1px solid var(--gray-50); margin: 0.5rem 0"
        ></div>
        <p-button
          [routerLink]="['/', roleRoute, 'create-ucc']"
          routerLinkActive="active-menu-item"
          #rlaCreateUcc="routerLinkActive"
          [routerLinkActiveOptions]="{ exact: true }"
          styleClass="sidebar-nav-button mt-2 px-6"
          [text]="true"
          (onClick)="clearClientPortfolioStorage()"
        >
          <i
            class="pi pi-address-book sidebar-icon"
            [ngClass]="{ 'active-icon': rlaCreateUcc.isActive }"
          ></i>
          @if (isExpanded) {
            <span class="sidebar-text">Create UCC</span>
          }
        </p-button>
      </div>
    }

    <!-- Transactions Section -->
    @if (
      role === 'BROKER ADMIN' ||
      role === 'RELATIONSHIP MANAGER' ||
      role === 'ADVISOR'
    ) {
      <div class="menu-section">
        @if (isExpanded) {
          <div class="section-header">
            <span class="section-title">TRANSACTIONS</span>
          </div>
        }
        <p-button
          [routerLink]="['/fresh/transaction', 'Purchase']"
          routerLinkActive="active-menu-item"
          [class.active-menu-item]="isPurchaseActive()"
          styleClass="sidebar-nav-button"
          [text]="true"
          (onClick)="clearTransactionContext(); clearClientPortfolioStorage()"
        >
          <i
            class="pi pi-shopping-cart sidebar-icon"
            [ngClass]="{ 'active-icon': isPurchaseActive() }"
          ></i>
          @if (isExpanded) {
            <span class="sidebar-text">Purchase</span>
          }
        </p-button>

        <p-button
          [routerLink]="['/transaction', 'Redeem']"
          routerLinkActive="active-menu-item"
          #rlaInvest="routerLinkActive"
          [routerLinkActiveOptions]="{ exact: false }"
          styleClass="sidebar-nav-button"
          [text]="true"
          (onClick)="clearTransactionContext(); clearClientPortfolioStorage()"
        >
          <i
            class="pi pi-money-bill sidebar-icon"
            [ngClass]="{ 'active-icon': rlaInvest.isActive }"
          ></i>
          @if (isExpanded) {
            <span class="sidebar-text">Redemption</span>
          }
        </p-button>

        @if (role === 'BROKER ADMIN' || role === 'ADVISOR') {
          <p-button
            [routerLink]="['/', roleRoute, 'transaction-history']"
            routerLinkActive="active-menu-item"
            #rlaHistory="routerLinkActive"
            [routerLinkActiveOptions]="{ exact: true }"
            styleClass="sidebar-nav-button"
            [text]="true"
            (onClick)="clearClientPortfolioStorage()"
          >
            <i
              class="pi pi-history sidebar-icon"
              [ngClass]="{ 'active-icon': rlaHistory.isActive }"
            ></i>
            @if (isExpanded) {
              <span class="sidebar-text">Transactions</span>
            }
          </p-button>
        }
      </div>
    }

    <!-- Utilities Section -->
    @if (
      role === 'BROKER ADMIN' ||
      role === 'RELATIONSHIP MANAGER' ||
      role === 'ADVISOR'
    ) {
      <div class="menu-section">
        @if (isExpanded) {
          <div class="section-header">
            <span class="section-title">UTILITIES</span>
          </div>
        }

        <p-button
          [routerLink]="['/scheme-analytics']"
          routerLinkActive="active-menu-item"
          #rlaScheme="routerLinkActive"
          [routerLinkActiveOptions]="{ exact: true }"
          styleClass="sidebar-nav-button"
          [text]="true"
          (onClick)="clearClientPortfolioStorage()"
        >
          <i
            class="pi pi-file sidebar-icon"
            [ngClass]="{ 'active-icon': rlaScheme.isActive }"
          ></i>
          @if (isExpanded) {
            <span class="sidebar-text">Scheme Analytics</span>
          }
        </p-button>

        <p-button
          [routerLink]="['/market-watch']"
          routerLinkActive="active-menu-item"
          #rlaMarket="routerLinkActive"
          [routerLinkActiveOptions]="{ exact: true }"
          styleClass="sidebar-nav-button"
          [text]="true"
          (onClick)="clearClientPortfolioStorage()"
        >
          <i
            class="pi pi-file sidebar-icon"
            [ngClass]="{ 'active-icon': rlaMarket.isActive }"
          ></i>
          @if (isExpanded) {
            <span class="sidebar-text">Market Watch</span>
          }
        </p-button>
      </div>
    }

    <!-- Others Section -->
    @if (
      role === 'BROKER ADMIN' ||
      role === 'RELATIONSHIP MANAGER' ||
      role === 'ADVISOR'
    ) {
      <div class="menu-section">
        @if (isExpanded) {
          <div class="section-header">
            <span class="section-title">OTHERS</span>
          </div>
        }
        @if (role === 'BROKER ADMIN' || role === 'ADVISOR') {
          <p-button
            [routerLink]="['/', roleRoute, 'reviewRequest']"
            routerLinkActive="active-menu-item"
            #rlaRequest="routerLinkActive"
            [routerLinkActiveOptions]="{ exact: true }"
            styleClass="sidebar-nav-button"
            [text]="true"
            (onClick)="clearClientPortfolioStorage()"
          >
            <i
              class="pi pi-envelope sidebar-icon"
              [ngClass]="{ 'active-icon': rlaRequest.isActive }"
            ></i>
            @if (isExpanded) {
              <span class="sidebar-text">Request</span>
            }
          </p-button>
        }

        <p-button
          [routerLink]="['/', roleRoute, 'report']"
          routerLinkActive="active-menu-item"
          #rlaReports="routerLinkActive"
          [routerLinkActiveOptions]="{ exact: false }"
          styleClass="sidebar-nav-button"
          [text]="true"
          (onClick)="clearClientPortfolioStorage()"
        >
          <i
            class="pi pi-chart-bar sidebar-icon"
            [ngClass]="{ 'active-icon': rlaReports.isActive }"
          ></i>
          @if (isExpanded) {
            <span class="sidebar-text">Reports</span>
          }
        </p-button>

        <p-button
          [routerLink]="['/', roleRoute, 'ucc-list']"
          routerLinkActive="active-menu-item"
          #rlaUccList="routerLinkActive"
          [routerLinkActiveOptions]="{ exact: true }"
          styleClass="sidebar-nav-button"
          [text]="true"
          (onClick)="clearClientPortfolioStorage()"
        >
          <i
            class="pi pi-id-card sidebar-icon"
            [ngClass]="{ 'active-icon': rlaUccList.isActive }"
          ></i>
          @if (isExpanded) {
            <span class="sidebar-text">UCC List</span>
          }
        </p-button>

        <p-button
          [routerLink]="['/', roleRoute, 'mandate']"
          routerLinkActive="active-menu-item"
          #rlaMandate="routerLinkActive"
          [routerLinkActiveOptions]="{ exact: true }"
          styleClass="sidebar-nav-button"
          [text]="true"
          (onClick)="clearClientPortfolioStorage()"
        >
          <i
            class="pi pi-file-edit sidebar-icon"
            [ngClass]="{ 'active-icon': rlaMandate.isActive }"
          ></i>
          @if (isExpanded) {
            <span class="sidebar-text">Mandate</span>
          }
        </p-button>
      </div>
    }
    <!-- Client Section -->
    @if (role === 'CLIENT') {
      <div class="menu-section">
        <p-button
          [routerLink]="'/client/profile'"
          routerLinkActive="active-menu-item"
          #rlaProfile="routerLinkActive"
          [routerLinkActiveOptions]="{ exact: true }"
          styleClass="sidebar-nav-button"
          [text]="true"
          (onClick)="clearClientPortfolioStorage()"
        >
          <i
            class="pi pi-user sidebar-icon"
            [ngClass]="{ 'active-icon': rlaProfile.isActive }"
          ></i>
          @if (isExpanded) {
            <span class="sidebar-text">Profile</span>
          }
        </p-button>

        <p-button
          [routerLink]="'/client/holdings'"
          routerLinkActive="active-menu-item"
          #rlaHoldings="routerLinkActive"
          [routerLinkActiveOptions]="{ exact: true }"
          styleClass="sidebar-nav-button"
          [text]="true"
          (onClick)="clearClientPortfolioStorage()"
        >
          <i
            class="pi pi-wallet sidebar-icon"
            [ngClass]="{ 'active-icon': rlaHoldings.isActive }"
          ></i>
          @if (isExpanded) {
            <span class="sidebar-text">Holdings</span>
          }
        </p-button>

        <p-button
          [routerLink]="['/fresh/transaction', 'Purchase']"
          routerLinkActive="active-menu-item"
          [class.active-menu-item]="isPurchaseActive()"
          styleClass="sidebar-nav-button"
          [text]="true"
          (onClick)="clearTransactionContext(); clearClientPortfolioStorage()"
        >
          <i
            class="pi pi-shopping-cart sidebar-icon"
            [ngClass]="{ 'active-icon': isPurchaseActive() }"
          ></i>
          @if (isExpanded) {
            <span class="sidebar-text">Purchase</span>
          }
        </p-button>

        <p-button
          [routerLink]="'/client/transactions'"
          routerLinkActive="active-menu-item"
          #rlaTransactions="routerLinkActive"
          [routerLinkActiveOptions]="{ exact: true }"
          styleClass="sidebar-nav-button"
          [text]="true"
          (onClick)="clearClientPortfolioStorage()"
        >
          <i
            class="pi pi-list sidebar-icon"
            [ngClass]="{ 'active-icon': rlaTransactions.isActive }"
          ></i>
          @if (isExpanded) {
            <span class="sidebar-text">Transactions</span>
          }
        </p-button>

        <p-button
          [routerLink]="'/client/mandate'"
          routerLinkActive="active-menu-item"
          #rlaClientMandate="routerLinkActive"
          [routerLinkActiveOptions]="{ exact: true }"
          styleClass="sidebar-nav-button"
          [text]="true"
          (onClick)="clearClientPortfolioStorage()"
        >
          <i
            class="pi pi-file-edit sidebar-icon"
            [ngClass]="{ 'active-icon': rlaClientMandate.isActive }"
          ></i>
          @if (isExpanded) {
            <span class="sidebar-text">Mandate</span>
          }
        </p-button>

        <p-button
          [routerLink]="'/client/report'"
          routerLinkActive="active-menu-item"
          #rlaClientReport="routerLinkActive"
          [routerLinkActiveOptions]="{ exact: false }"
          styleClass="sidebar-nav-button"
          [text]="true"
          (onClick)="clearClientPortfolioStorage()"
        >
          <i
            class="pi pi-chart-bar sidebar-icon"
            [ngClass]="{ 'active-icon': rlaClientReport.isActive }"
          ></i>
          @if (isExpanded) {
            <span class="sidebar-text">Reports</span>
          }
        </p-button>
      </div>
    }
  </div>
</div>
